import { useState, useEffect } from 'react';
import axios from 'axios';
import { Column } from './Column';
import { LineGraph } from './LineGraph';
import { Currencies } from '../Components/Currencies';
import { getToken } from '../utils';
function TableBodyData() {
  const [currencyRates, setCurrencyRates] = useState([]);
  const { token: userToken } = getToken();

  const { itemClicked, amountInputs, setItemClicked } = Column();
  const { currencys } = Currencies();
  const fallbackgaraphdata = [
    {
      amount: 0,
    },
    {
      amount: 7,
    },
  ];

  const allCurrency = currencys?.map((currency) => ({
    id: currency.id,
    name: currency.name,
    flag: currency.country.flag,
    code: currency.symbol,
  }));

  useEffect(() => {
    if (allCurrency?.length && Object.keys(itemClicked).length === 0)
      setItemClicked(allCurrency[0]);
  }, [allCurrency, itemClicked]);

  useEffect(() => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_BASE_URL}/exchange-rates/get-rate-list`;
      try {
        const response = await axios.post(
          url,
          {
            base_currency_id: itemClicked.id,
          },
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );

        setCurrencyRates(response?.data);

        // console.log(response);
      } catch (error) {
        console.log(error);
      }
    };
    // setTests(false);
    fetchData();
  }, [userToken, itemClicked]);

  const curerencyRatesArrays = currencyRates?.map((rate) => {
    const currentChange = Number(rate?.rate[rate?.rate?.length - 1]?.amount);
    const lastChange = Number(rate?.rate[0]?.amount);
    return {
      currency: (
        <div className='flex flex-row items-center gap-3 text-p-bk font-normal'>
          <img src={rate?.country?.flag} alt={rate?.name} className='w-5 h-3' />
          <p>{rate?.name + ' ' + rate?.symbol}</p>
        </div>
      ),

      usd: amountInputs
        ? (amountInputs * rate?.price)?.toFixed(4)?.toLocaleString()
        : (rate?.price * 1)?.toFixed(4),
      perChange: (
        <p
          className={
            currentChange > lastChange
              ? 'text-green-500'
              : currentChange === lastChange
              ? 'tex-p-bk'
              : 'text-red-500'
          }
        >
          {`${
            currentChange > lastChange
              ? '+'
              : currentChange === lastChange
              ? ''
              : '-'
          } ${
            rate?.rate.length
              ? rate?.rate.length > 1
                ? (
                    ((rate?.rate[0]?.amount - rate?.rate[1]?.amount) /
                      rate?.rate[1]?.amount) *
                    100
                  )?.toFixed(4)
                : rate?.rate[0]?.amount * 1
              : 0
          }`}
        </p>
      ),
      chart: (
        <LineGraph
          chart24Data={rate?.rate?.length > 1 ? rate?.rate : fallbackgaraphdata}
        />
      ),
      action: (
        <div className='w-full justify-center flex flex-row gap-4 text-p-wh text-xs'>
          <button className='py-1.5 px-6 bg-green-500 hover:bg-green-300 rounded active:bg-green-700'>
            Buy
          </button>
          <button className='py-1.5 px-6 bg-red-500 hover:bg-red-300 rounded active:bg-red-700'>
            Sell
          </button>
        </div>
      ),
    };
  });

  // console.log(itemClicked);
  return { curerencyRatesArrays, itemClicked, setItemClicked };
}

export default TableBodyData;
